/*
 * @FileName       : store.ts
 * @Version        : 1.0
 * @DateOfCreation : 04/21/2020
 * @Author         : $u^^!t @ FFF Enterprises
 * @Dependencies   : N/A
 * @Description    : Store for app.
 *
 * Copyright (c) 2020, FFF Enterprises. All rights reserved.
 */

import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
//import logger from 'redux-logger';

import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router'

import createRootReducer  from '../reducers';
import rootSaga from '../sagas';

const sagaMiddleware = createSagaMiddleware();

export const history = createBrowserHistory()

const composeEnhancer: typeof compose = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
export const store = createStore(
    createRootReducer(history),
    {},
    composeEnhancer(
      applyMiddleware(
        // logger,
        sagaMiddleware,
        routerMiddleware(history),
      ),
    ),
  );

export default function configureStore(preloadedState?: any) {
  sagaMiddleware.run(rootSaga);
  return store;
}
